import { render, staticRenderFns } from "./weixin-pay.vue?vue&type=template&id=44bb1a12&scoped=true"
import script from "./weixin-pay.vue?vue&type=script&lang=js"
export * from "./weixin-pay.vue?vue&type=script&lang=js"
import style0 from "./weixin-pay.vue?vue&type=style&index=0&id=44bb1a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb1a12",
  null
  
)

export default component.exports